/* Deleagenten (snippets/deleagent.liquid). Sender samtalen til Edge Function «deleagent» og
   viser svaret. AI-samtalen ligger bare i nettleserfanen (sessionStorage), ikke hos oss.
   Valgt sykkel (localStorage mcs_sykkel) sendes med, så kunden slipper å gjenta den.

   Kundechat: når agenten kobler kunden videre, kan kunden chatte med en av oss i Motodesk
   (data-kundechat). Kunden fyller inn navn og e-post, og samtalen går rett til Motodesk.
   Svarer ingen innen 45 sekunder, får kunden spørsmål om å legge igjen beskjed; sier kunden
   nei, slettes samtalen. Tokenet til samtalen ligger i fanen og sendes i kroppen, ikke i
   adressen. */
(function () {
  const rot = document.querySelector('[data-deleagent]');
  if (!rot || window.mcsChat) return;
  const API = rot.dataset.api;
  const KUNDECHAT = rot.dataset.kundechat || '';
  const vindu = rot.querySelector('.dla__vindu');
  const knapp = rot.querySelector('[data-dla-apne]');
  const logg = rot.querySelector('[data-dla-logg]');
  const skjema = rot.querySelector('[data-dla-skjema]');
  const felt = rot.querySelector('[data-dla-felt]');
  const send = rot.querySelector('.dla__send');
  const tittel = rot.querySelector('.dla__tittel');
  const under = rot.querySelector('.dla__under');
  const merk = rot.querySelector('.dla__merk');
  const LAGER = 'mcs_chat';
  const AI_TITTEL = tittel.textContent;
  const AI_UNDER = under.textContent;
  const AI_MERK = merk.textContent;
  const AI_PLASS = felt.placeholder;

  // live: { token, status, etter, meldinger: [{id, fra, tekst, navn}], ansatt, spurt, beskjedVist, ferdig }
  let tilstand = { meldinger: [], wa: null, apen: false, live: null, skjemaApent: false };
  try { tilstand = Object.assign(tilstand, JSON.parse(sessionStorage.getItem(LAGER) || '{}')); } catch (e) { /* privat modus */ }
  const lagre = () => { try { sessionStorage.setItem(LAGER, JSON.stringify(tilstand)); } catch (e) { /* privat modus */ } };

  const sykkel = () => {
    try { const s = JSON.parse(localStorage.getItem('mcs_sykkel') || 'null'); return s && s.merke && s.modell ? s : null; } catch (e) { return null; }
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // Enkel markdown: lenker (bare våre egne og wa.me), **fet**, punktlister og avsnitt.
  function tilHtml(tekst) {
    const lenke = (t) => t.replace(/\[([^\]]{1,200})\]\(([^)\s]{1,600})\)/g, (m, navn, url) => {
      const u = url.replace(/&amp;/g, '&');
      const ok = /^\/(?!\/)/.test(u) || /^https:\/\/(www\.)?mcservice\.as\//.test(u) || /^https:\/\/wa\.me\//.test(u);
      return ok ? `<a href="${esc(u)}"${/^https:\/\/wa\.me/.test(u) ? ' target="_blank" rel="noopener"' : ''}>${navn}</a>` : navn;
    }).replace(/\*\*([^*]{1,200})\*\*/g, '<strong>$1</strong>');
    const blokker = esc(tekst).split(/\n{2,}/);
    return blokker.map((b) => {
      const linjer = b.split('\n');
      if (linjer.every((l) => /^\s*[-•]\s+/.test(l))) return '<ul>' + linjer.map((l) => `<li>${lenke(l.replace(/^\s*[-•]\s+/, ''))}</li>`).join('') + '</ul>';
      return `<p>${linjer.map(lenke).join('<br>')}</p>`;
    }).join('');
  }

  function velkomst() {
    if (rot.hasAttribute('data-verksted')) {
      return 'Hei! Jeg kan svare på verkstedpriser, vinterlagring og omtrentlig ventetid, og hjelpe deg å finne deler. Time til service bestiller du i [registreringsskjemaet](/pages/henvendelse-til-verkstedet).';
    }
    const s = sykkel();
    return s
      ? `Hei! Jeg ser du har valgt **${s.merke} ${s.modell} ${s.aar || ''}**. Hva trenger du til den?`
      : 'Hei! Jeg hjelper deg å finne deler og utstyr til motorsykkelen. Skriv merke, modell og årsmodell, og hva du trenger.';
  }

  // ---------- Kundechat mot Motodesk ----------
  let bemannet = null; // ukjent til vi har spurt
  let poll = null;

  async function motodesk(kropp) {
    const r = await fetch(KUNDECHAT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(kropp),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { const e = new Error(d.melding || d.feil || String(r.status)); e.status = r.status; throw e; }
    return d;
  }

  async function sjekkBemannet() {
    if (!KUNDECHAT) return false;
    try {
      const r = await fetch(KUNDECHAT, { headers: { Accept: 'application/json' } });
      const d = await r.json();
      bemannet = !!d.bemannet;
    } catch (e) { bemannet = false; }
    return bemannet;
  }

  const live = () => tilstand.live && !tilstand.live.ferdig ? tilstand.live : null;

  function settModus() {
    const l = live();
    if (l) {
      tittel.textContent = 'MC Service';
      under.textContent = l.ansatt ? `Du snakker med ${l.ansatt}` : l.status === 'beskjed' ? 'Beskjed til oss' : 'Venter på en av oss …';
      merk.textContent = 'Samtalen lagres hos MC Service så vi kan svare deg. Se personvernerklæringen.';
      felt.placeholder = l.status === 'beskjed' ? 'Skriv beskjeden din …' : 'Skriv til oss …';
    } else {
      tittel.textContent = AI_TITTEL; under.textContent = AI_UNDER; merk.textContent = AI_MERK; felt.placeholder = AI_PLASS;
    }
  }

  function overleveringHtml() {
    const o = tilstand.wa;
    if (!o) return '';
    if (o.kundechat && KUNDECHAT) {
      if (tilstand.skjemaApent) return skjemaHtml();
      const tekst = bemannet === false ? 'Legg igjen beskjed' : 'Chat med oss';
      return `<div class="dla__wa"><button type="button" class="dla__chatknapp" data-dla-start>${tekst}</button>
        <small>${bemannet === false ? 'Ingen er på jobb akkurat nå. Legg igjen en beskjed, så svarer vi på e-post.' : 'En av oss svarer deg her i chatten.'}</small></div>`;
    }
    if (o.url) {
      return `<div class="dla__wa"><a href="${esc(o.url)}" target="_blank" rel="noopener">Fortsett på WhatsApp</a>${o.skjema ? `<a class="dla__skjemaknapp" href="${esc(o.skjema)}" data-dla-kundeservice>Send til kundeservice</a>` : ''}<small>${o.tilgjengelig ? 'Vi er tilgjengelige nå.' : 'Vi er ikke på jobb akkurat nå, men svarer neste virkedag.'}</small></div>`;
    }
    return '';
  }

  function skjemaHtml() {
    const beskjed = bemannet === false;
    return `<form class="dla__kontakt" data-dla-kontakt>
      <p><strong>${beskjed ? 'Legg igjen en beskjed' : 'Chat med en av oss'}</strong><br>
      ${beskjed ? 'Vi svarer på e-post så snart vi er på jobb.' : 'Vi trenger navn og e-post i tilfelle vi må svare deg på mail.'}</p>
      <label>Navn<input name="navn" autocomplete="name" required maxlength="200"></label>
      <label>E-post<input name="epost" type="email" autocomplete="email" required maxlength="200"></label>
      <label>Telefon (valgfritt)<input name="telefon" type="tel" autocomplete="tel" maxlength="40"></label>
      ${beskjed ? '<label>Beskjed<textarea name="beskjed" rows="3" required maxlength="2000"></textarea></label>' : ''}
      <p class="dla__liten">Navn, e-post og samtalen lagres hos MC Service for å svare deg. Les mer i <a href="/pages/personvernerklaering">personvernerklæringen</a>.</p>
      <div class="dla__rad"><button type="submit" class="dla__chatknapp">${beskjed ? 'Send beskjed' : 'Start chat'}</button>
      <button type="button" class="dla__lenkeknapp" data-dla-avbryt-skjema>Avbryt</button></div>
      <p class="dla__feil" data-dla-feil hidden></p>
    </form>`;
  }

  function liveHtml() {
    const l = tilstand.live;
    if (!l) return '';
    let h = '<div class="dla__skille">Samtale med MC Service</div>';
    h += l.meldinger.map((m) => m.fra === 'kunde'
      ? `<div class="dla__mld dla__mld--kunde">${esc(m.tekst)}</div>`
      : `<div class="dla__mld dla__mld--ansatt"><span class="dla__navn">${esc(m.navn || 'MC Service')}</span>${esc(m.tekst)}</div>`).join('');
    if (l.ferdig) {
      h += `<div class="dla__system">${esc(l.ferdig)}</div>`;
      return h;
    }
    if (l.status === 'venter' && !l.spurt) {
      h += '<div class="dla__system">Venter på en av oss … Du kan skrive spørsmålet ditt mens du venter.</div>';
    }
    if (l.status === 'venter' && l.spurt) {
      h += `<div class="dla__system">Alle kundebehandlerne er opptatt akkurat nå. Vil du legge igjen en beskjed, så kontakter vi deg på e-post?
        <div class="dla__rad"><button type="button" class="dla__chatknapp" data-dla-beskjed>Legg igjen beskjed</button>
        <button type="button" class="dla__lenkeknapp" data-dla-vent>Vent litt til</button>
        <button type="button" class="dla__lenkeknapp" data-dla-nei>Nei takk</button></div></div>`;
    }
    if (l.status === 'beskjed') {
      h += '<div class="dla__system">Takk! Beskjeden din er lagret, og vi svarer på e-post så snart vi kan. Du kan skrive mer her hvis du vil.</div>';
    }
    if (l.status === 'aktiv' || l.status === 'beskjed' || l.status === 'venter') {
      h += '<div class="dla__rad dla__rad--hoyre"><button type="button" class="dla__lenkeknapp" data-dla-avslutt>Avslutt samtalen</button></div>';
    }
    return h;
  }

  function tegn() {
    const alle = tilstand.meldinger.length ? tilstand.meldinger : [{ rolle: 'agent', tekst: velkomst() }];
    logg.innerHTML = alle.map((m) => m.rolle === 'kunde'
      ? `<div class="dla__mld dla__mld--kunde">${esc(m.tekst)}</div>`
      : `<div class="dla__mld dla__mld--agent">${tilHtml(m.tekst)}</div>`).join('');
    if (!live()) logg.insertAdjacentHTML('beforeend', overleveringHtml());
    logg.insertAdjacentHTML('beforeend', liveHtml());
    settModus();
    logg.scrollTop = logg.scrollHeight;
  }

  async function startLive(data) {
    const beskjed = bemannet === false;
    const d = await motodesk({
      handling: 'start',
      kilde: rot.hasAttribute('data-verksted') ? 'verksted' : 'nettbutikk',
      navn: data.navn, epost: data.epost, telefon: data.telefon,
      sammendrag: (tilstand.wa && tilstand.wa.sammendrag) || '',
      side: location.pathname,
      beskjed,
    });
    tilstand.live = { token: d.token, status: beskjed ? 'beskjed' : 'venter', etter: 0, meldinger: [], ansatt: null, spurt: false, ferdig: null };
    tilstand.skjemaApent = false;
    tilstand.wa = null;
    lagre();
    if (beskjed && data.beskjed) await sendLive(data.beskjed);
    startPoll();
    tegn();
  }

  async function sendLive(tekst) {
    const l = live();
    if (!l) return;
    l.meldinger.push({ id: 0, fra: 'kunde', tekst }); lagre(); tegn();
    try {
      await motodesk({ handling: 'send', token: l.token, tekst });
      await hent();
    } catch (e) {
      l.meldinger.pop();
      if (e.status === 404 || /avsluttet/i.test(e.message)) avsluttLokalt('Samtalen er avsluttet.');
      else { l.meldinger.push({ id: 0, fra: 'system', tekst: e.message || 'Meldingen kom ikke fram. Prøv igjen.' }); }
      lagre(); tegn();
    }
  }

  function avsluttLokalt(tekst) {
    if (tilstand.live) tilstand.live.ferdig = tekst;
    stoppPoll(); lagre(); tegn();
  }

  async function hent() {
    const l = live();
    if (!l) return;
    let d;
    try { d = await motodesk({ handling: 'hent', token: l.token, etter: l.etter }); }
    catch (e) {
      if (e.status === 404) avsluttLokalt('Samtalen er avsluttet.');
      return;
    }
    // Kundens egne meldinger er allerede vist (id 0); erstatt dem med de lagrede.
    if (d.meldinger.length) {
      l.meldinger = l.meldinger.filter((m) => m.id !== 0 || m.fra === 'system');
      for (const m of d.meldinger) {
        if (!l.meldinger.some((x) => x.id === m.id)) l.meldinger.push(m);
        l.etter = Math.max(l.etter, m.id);
      }
      if (d.meldinger.some((m) => m.fra === 'ansatt') && vindu.hidden) knapp.classList.add('har-nytt');
    }
    l.status = d.status;
    l.ansatt = d.ansatt || null;
    if (d.status === 'venter' && !l.spurt && d.venter_sek >= (l.grense || 45)) l.spurt = true;
    if (d.status === 'avsluttet') { avsluttLokalt('Samtalen er avsluttet. Takk for praten! Du kan fortsatt spørre assistenten.'); return; }
    lagre(); tegn();
  }

  function startPoll() {
    stoppPoll();
    const tikk = async () => {
      const l = live();
      if (!l) return;
      await hent();
      const ms = l.status === 'beskjed' ? 15000 : document.hidden ? 8000 : 2500;
      poll = setTimeout(tikk, ms);
    };
    poll = setTimeout(tikk, 1500);
  }
  function stoppPoll() { if (poll) { clearTimeout(poll); poll = null; } }

  // ---------- AI-assistenten ----------
  function apne(forslag) {
    tilstand.apen = true; lagre();
    vindu.hidden = false; rot.classList.add('er-apen'); knapp.setAttribute('aria-expanded', 'true');
    knapp.classList.remove('har-nytt');
    tegn();
    if (forslag) felt.value = forslag;
    setTimeout(() => felt.focus(), 50);
  }
  function lukk() {
    tilstand.apen = false; lagre();
    vindu.hidden = true; rot.classList.remove('er-apen'); knapp.setAttribute('aria-expanded', 'false');
  }

  async function spor(tekst) {
    tilstand.meldinger.push({ rolle: 'kunde', tekst });
    tilstand.wa = null; tilstand.skjemaApent = false;
    if (tilstand.live && tilstand.live.ferdig) tilstand.live = null;
    lagre(); tegn();
    logg.insertAdjacentHTML('beforeend', '<div class="dla__mld dla__mld--agent dla__mld--venter">Et øyeblikk …</div>');
    logg.scrollTop = logg.scrollHeight;
    send.disabled = true;
    try {
      const r = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ meldinger: tilstand.meldinger.slice(-12), sykkel: sykkel(), side: location.pathname, ...(KUNDECHAT ? { kanal: 'kundechat' } : {}) }),
      });
      const d = await r.json().catch(() => ({}));
      tilstand.meldinger.push({ rolle: 'agent', tekst: d.svar || 'Beklager, noe gikk galt. Prøv igjen om litt.' });
      tilstand.wa = d.overlevering || null;
      if (tilstand.wa && tilstand.wa.kundechat) await sjekkBemannet();
    } catch (e) {
      tilstand.meldinger.push({ rolle: 'agent', tekst: 'Fikk ikke kontakt med assistenten. Sjekk nettet og prøv igjen.' });
    }
    tilstand.meldinger = tilstand.meldinger.slice(-30);
    lagre(); tegn();
    send.disabled = false;
    felt.focus();
  }

  // ---------- Klikk i loggen ----------
  logg.addEventListener('click', async (e) => {
    const t = e.target;
    if (t.closest('[data-dla-kundeservice]') && tilstand.wa) {
      try { sessionStorage.setItem('mcs_kundeservice', tilstand.wa.sammendrag || ''); } catch (err) { /* privat modus */ }
      return;
    }
    if (t.closest('[data-dla-start]')) {
      if (bemannet === null) await sjekkBemannet();
      tilstand.skjemaApent = true; lagre(); tegn();
      const f = logg.querySelector('[data-dla-kontakt] input'); if (f) f.focus();
      return;
    }
    if (t.closest('[data-dla-avbryt-skjema]')) { tilstand.skjemaApent = false; lagre(); tegn(); return; }
    const l = live();
    if (!l) return;
    if (t.closest('[data-dla-beskjed]')) {
      try { const d = await motodesk({ handling: 'beskjed', token: l.token }); l.status = d.status; } catch (err) { /* hent retter opp */ }
      lagre(); tegn(); startPoll();
    } else if (t.closest('[data-dla-vent]')) {
      l.spurt = false; l.grense = (l.grense || 45) + 60; lagre(); tegn();
    } else if (t.closest('[data-dla-nei]') || t.closest('[data-dla-avslutt]')) {
      const varVenter = l.status === 'venter';
      try { await motodesk({ handling: 'avbryt', token: l.token }); } catch (err) { /* allerede borte */ }
      avsluttLokalt(varVenter ? 'Greit, samtalen er ikke lagret. Du kan fortsatt spørre assistenten.' : 'Samtalen er avsluttet. Takk for praten!');
    }
  });

  logg.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-dla-kontakt]');
    if (!f) return;
    e.preventDefault();
    const fd = new FormData(f);
    const data = Object.fromEntries([...fd.entries()].map(([k, v]) => [k, String(v).trim()]));
    const feil = f.querySelector('[data-dla-feil]');
    const knappen = f.querySelector('button[type="submit"]');
    knappen.disabled = true; feil.hidden = true;
    try { await startLive(data); }
    catch (err) { feil.textContent = err.message || 'Fikk ikke startet chatten. Prøv igjen.'; feil.hidden = false; knappen.disabled = false; }
  });

  knapp.addEventListener('click', () => apne());
  rot.querySelector('[data-dla-lukk]').addEventListener('click', lukk);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !vindu.hidden) lukk(); });
  skjema.addEventListener('submit', (e) => {
    e.preventDefault();
    const t = felt.value.trim();
    if (!t || send.disabled) return;
    felt.value = ''; felt.style.height = '';
    if (live()) sendLive(t.slice(0, 2000));
    else spor(t.slice(0, 800));
  });
  felt.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); skjema.requestSubmit(); }
  });
  felt.addEventListener('input', () => { felt.style.height = 'auto'; felt.style.height = Math.min(felt.scrollHeight, 120) + 'px'; });

  window.mcsChat = { aapne: apne, lukk };

  // Lenke i den horisontale hovedmenyen (desktop), så chatten ikke bare finnes nede i hjørnet.
  const meny = document.querySelector('ul.navigation-main');
  if (meny && !meny.querySelector('[data-dla-meny]')) {
    meny.insertAdjacentHTML('beforeend', `<li class="navigation-item dla-meny"><a href="#" role="button" data-dla-meny>
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2zm3 6v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z"/></svg>
      ${rot.hasAttribute('data-verksted') ? 'Spør oss' : 'Spør om deler'}</a></li>`);
    meny.querySelector('[data-dla-meny]').addEventListener('click', (e) => { e.preventDefault(); apne(); });
  }

  // En pågående samtale fortsetter når kunden går til en annen side.
  if (live()) startPoll();
  if (tilstand.apen && (window.innerWidth >= 750 || live())) apne();
  else if (live()) tegn();
})();
